import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import { union, without } from './utils/11debdea1ea47c9f720142fb11e53929e0b970176470de43e28a0ed04eb22b90.cfe-internal.js';

var EnterLeaveCounter = /*#__PURE__*/function () {
  function EnterLeaveCounter(isNodeInDocument) {
    _classCallCheck(this, EnterLeaveCounter);
    this.entered = [];
    this.isNodeInDocument = isNodeInDocument;
  }
  _createClass(EnterLeaveCounter, [{
    key: "enter",
    value: function enter(enteringNode) {
      var _this = this,
        _context;
      var previousLength = this.entered.length;
      var isNodeEntered = function isNodeEntered(node) {
        return _this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
      };
      this.entered = union(_filterInstanceProperty(_context = this.entered).call(_context, isNodeEntered), [enteringNode]);
      return previousLength === 0 && this.entered.length > 0;
    }
  }, {
    key: "leave",
    value: function leave(leavingNode) {
      var _context2;
      var previousLength = this.entered.length;
      this.entered = without(_filterInstanceProperty(_context2 = this.entered).call(_context2, this.isNodeInDocument), leavingNode);
      return previousLength > 0 && this.entered.length === 0;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.entered = [];
    }
  }]);
  return EnterLeaveCounter;
}();

export { EnterLeaveCounter };
